module.exports = __webpack_public_path__ + "static/img/header_bg2.ab6e9c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/recall/header/header_bg2.png
// module id = Wg01
// module chunks = 6